import { cn } from '@/lib/utils'

interface ExpirationBadgeProps {
  count: number
  type?: 'urgent' | 'alert' | 'normal'
  daysUntilExpiry?: number // Keep for backward compatibility
}

export function ExpirationBadge({
  count,
  type,
  daysUntilExpiry,
}: ExpirationBadgeProps) {
  // If type is provided (new format), use it directly
  // Otherwise fall back to calculating from daysUntilExpiry (legacy format)
  const getBadgeType = () => {
    if (type) {
      return type
    }

    if (daysUntilExpiry === undefined) {
      return 'normal'
    }

    if (daysUntilExpiry < 0 || daysUntilExpiry <= 7) {
      return 'urgent'
    } else if (daysUntilExpiry <= 30) {
      return 'alert'
    } else {
      return 'normal'
    }
  }

  const badgeType = getBadgeType()

  // Determinar el color según el tipo
  const getColorClasses = () => {
    switch (badgeType) {
      case 'urgent':
        return 'text-[#991B1B]'
      case 'alert':
        return 'text-[#713F12]'
      case 'normal':
      default:
        return 'text-[#166534]'
    }
  }

  const getBackgroundClasses = () => {
    switch (badgeType) {
      case 'urgent':
        return 'bg-[#FECACA]'
      case 'alert':
        return 'bg-[#FEF9C3]'
      case 'normal':
      default:
        return 'bg-[#BBF7D0]'
    }
  }

  const colorClasses = getColorClasses()
  const backgroundClasses = getBackgroundClasses()

  return (
    <div
      className={cn(
        'inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold',
        backgroundClasses,
        colorClasses
      )}
    >
      {count}
    </div>
  )
}
